import { useMemo } from 'react';

export const useRowData = (data) =>
  useMemo(() => {
    return Object.entries(data || {}).reduce((acc, [key, value]) => {
      const itemsData = Object.entries(value).map(([date, info]) => ({
        itemHeader: date,
        info: [info],
      }));

      if (itemsData.length > 0) {
        acc.push({ mainTitle: key, data: itemsData });
      }

      return acc;
    }, []);
  }, [data]);
